import { pgTable, uuid, text, unique, integer, boolean, foreignKey, } from 'drizzle-orm/pg-core';
import { relations } from 'drizzle-orm';
import { isoTimestamp, sortOrder } from '../../utils';
import { MetricType } from '../../enums';
import { orgPrimaryKey, orgTableBase } from '../org-id';
import { TrainingFocus, TrainingType } from '../misc';
import { ExerciseMetric } from '../metrics';
export const Scheme = pgTable('scheme', {
    ...orgTableBase,
    name: text('name').notNull(),
    trainingTypeId: uuid('training_type_id').notNull(),
    deletedAt: isoTimestamp('deleted_at'),
}, (table) => ({
    pk: orgPrimaryKey(table),
    typeFk: foreignKey({
        columns: [table.orgId, table.trainingTypeId],
        foreignColumns: [TrainingType.orgId, TrainingType.id],
    }),
}));
export const Scheme_Relations = relations(Scheme, ({ many, one }) => ({
    sets: many(SchemeSet),
    metrics: many(SchemeMetric),
    focuses: many(SchemeFocus),
    trainingType: one(TrainingType, {
        fields: [Scheme.orgId, Scheme.trainingTypeId],
        references: [TrainingType.orgId, TrainingType.id],
    }),
}));
export const SchemeMetric = pgTable('scheme_metric', {
    ...orgTableBase,
    sortOrder,
    schemeId: uuid('scheme_id').notNull(),
    metricId: uuid('metric_id').notNull(),
    metricName: text('metric_name').notNull(),
    metricType: MetricType('metric_type').notNull(),
}, (table) => ({
    pk: orgPrimaryKey(table),
    uq1: unique().on(table.orgId, table.schemeId, table.metricId),
    uq2: unique().on(table.orgId, table.schemeId, table.sortOrder),
    metricFk: foreignKey({
        columns: [table.orgId, table.metricId],
        foreignColumns: [ExerciseMetric.orgId, ExerciseMetric.id],
    }),
    schemeFk: foreignKey({
        columns: [table.orgId, table.schemeId],
        foreignColumns: [Scheme.orgId, Scheme.id],
    }),
}));
export const SchemeMetric_Relations = relations(SchemeMetric, ({ one }) => ({
    scheme: one(Scheme, {
        fields: [SchemeMetric.orgId, SchemeMetric.schemeId],
        references: [Scheme.orgId, Scheme.id],
    }),
}));
export const SchemeSet = pgTable('scheme_set', {
    ...orgTableBase,
    sortOrder,
    sessionIndex: integer('session_index').notNull(),
    cycleIndex: integer('cycle_index').notNull(),
    schemeId: uuid('scheme_id').notNull(),
}, (table) => ({
    pk: orgPrimaryKey(table),
    uq: unique().on(table.orgId, table.schemeId, table.sessionIndex, table.cycleIndex, table.sortOrder),
    schemeFk: foreignKey({
        columns: [table.orgId, table.schemeId],
        foreignColumns: [Scheme.orgId, Scheme.id],
    }),
}));
export const SchemeSet_Relations = relations(SchemeSet, ({ one, many }) => ({
    scheme: one(Scheme, {
        fields: [SchemeSet.orgId, SchemeSet.schemeId],
        references: [Scheme.orgId, Scheme.id],
    }),
    metrics: many(SchemeSetMetric),
}));
export const SchemeSetMetric = pgTable('scheme_set_metric', {
    ...orgTableBase,
    schemeSetId: uuid('scheme_set_id').notNull(),
    metricId: uuid('metric_id').notNull(),
    input: text('input').notNull(),
    forCollection: boolean('for_collection').notNull(),
}, (table) => ({
    pk: orgPrimaryKey(table),
    uq: unique().on(table.orgId, table.schemeSetId, table.metricId),
    metricFk: foreignKey({
        columns: [table.orgId, table.metricId],
        foreignColumns: [ExerciseMetric.orgId, ExerciseMetric.id],
    }),
    schemeSetFk: foreignKey({
        columns: [table.orgId, table.schemeSetId],
        foreignColumns: [SchemeSet.orgId, SchemeSet.id],
    }),
}));
export const SchemeSetMetric_Relations = relations(SchemeSetMetric, ({ one }) => ({
    set: one(SchemeSet, {
        fields: [SchemeSetMetric.orgId, SchemeSetMetric.schemeSetId],
        references: [SchemeSet.orgId, SchemeSet.id],
    }),
}));
export const SchemeFocus = pgTable('scheme_focus', {
    ...orgTableBase,
    sortOrder,
    schemeId: uuid('scheme_id').notNull(),
    focusId: uuid('focus_id').notNull(),
}, (table) => ({
    pk: orgPrimaryKey(table),
    uq1: unique().on(table.orgId, table.schemeId, table.focusId),
    uq2: unique().on(table.orgId, table.schemeId, table.sortOrder),
    schemeFk: foreignKey({
        columns: [table.orgId, table.schemeId],
        foreignColumns: [Scheme.orgId, Scheme.id],
    }),
    focusFk: foreignKey({
        columns: [table.orgId, table.focusId],
        foreignColumns: [TrainingFocus.orgId, TrainingFocus.id],
    }),
}));
export const SchemeFocus_Relations = relations(SchemeFocus, ({ one }) => ({
    scheme: one(Scheme, {
        fields: [SchemeFocus.orgId, SchemeFocus.schemeId],
        references: [Scheme.orgId, Scheme.id],
    }),
    focus: one(TrainingFocus, {
        fields: [SchemeFocus.orgId, SchemeFocus.focusId],
        references: [TrainingFocus.orgId, TrainingFocus.id],
    }),
}));
//# sourceMappingURL=scheme.js.map